interface ReplyCandidate {
  type?: unknown
  parentId?: unknown
  userId?: unknown
  metadata?: { requestId?: unknown } | null
}

/**
 * True when `entities` contains the persisted assistant comment produced by
 * the stream request `requestId` on `agentId`. Used to hide the synthetic
 * live-stream item the moment the durable comment is renderable — the
 * flicker-free handoff (spec §Phase 1c).
 *
 * The server stamps `metadata.requestId` in `persistAssistantComment`
 * (backend/ai-api). Older replies without the stamp never match, so streams
 * from before the deploy simply keep the live item's final text — content is
 * identical, no data loss.
 */
export const hasPersistedReply = (entities: unknown[], agentId: string, requestId: string): boolean =>
  entities.some(entity => {
    if (typeof entity !== 'object' || entity === null) {
      return false
    }
    const candidate = entity as ReplyCandidate
    return (
      candidate.type === 'comment' &&
      candidate.parentId === agentId &&
      candidate.userId === 'assistant' &&
      candidate.metadata?.requestId === requestId
    )
  })
